import { ALLOWED_EXTENSIONS_IMAGE_UPLOAD, FILE_MAX_SIZE, UPLOAD_ERROR_TYPE } from 'constants/upload';

/**
 * @typedef {{
 *  maxSize?: number,
 *  allowedExtensions?: string[],
 * }} UploadLimits
 */

/**
 * @param {import('react-dropzone').FileWithPath} file
 * @param {UploadLimits} limits
 * @returns {string|undefined}
 */
export const checkUploadRules = (file, limits = {}) => {
  const extension = file.name.split('.').pop();
  const { allowedExtensions = ALLOWED_EXTENSIONS_IMAGE_UPLOAD, maxSize = FILE_MAX_SIZE } = limits;
  if (!allowedExtensions.includes(extension)) {
    throw new Error(UPLOAD_ERROR_TYPE.TYPE);
  }
  if (file.size > maxSize) {
    throw new Error(UPLOAD_ERROR_TYPE.SIZE);
  }
};

/**
 * @param {import('react-dropzone').FileWithPath} file
 * @returns {Promise}
 */
export const loadPicture = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = ({ target }) => {
      const uploadData = target.result;
      resolve(uploadData);
    };
    reader.onerror = () => {
      reader.abort();
      reject(reader.error);
    };
    reader.readAsDataURL(file);
  });

export const getUploadError = errorType => {
  switch (errorType) {
    case UPLOAD_ERROR_TYPE.TYPE:
      return 'web.upload.failure.type';

    case UPLOAD_ERROR_TYPE.SIZE:
      return 'web.upload.failure.size';

    default:
      return 'web.upload.failure';
  }
};

export const transformFileToBase64 = file => new Promise(resolve => {
  const reader = new FileReader();
  reader.onload = event => {
    const base64 = event.target.result;
    resolve(base64);
  };
  reader.readAsDataURL(file);
});

export const transformFileToBinary = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = readerEvt => {
    resolve(readerEvt.target.result);
  };
  reader.onerror = error => {
    reject(error);
  };
  reader.readAsArrayBuffer(file);
});
